// import { getPwdRule } from "@/api/index";
import { getCookie, setCookie } from '@/utils/cookie';
import httpStatusCode from  "@/utils/httpStatusCode"

import i18n from '@/utils/i18n';
const languages = i18n.messages[i18n.locale]

// 校验密码
export default function checkPassword(value, callback){
    // 判断是否有缓存
    if (!getCookie("passwordRolu")) {
        getData().then(res=> {
            comFun (value, callback, res,getCookie("userAttr"))
        })
    } else {
        comFun (value, callback, getCookie("passwordRolu"),getCookie("userAttr"))
    }
}


// 获取密码规则
function getData() {
	return new Promise(function(resolve, reject) {
		// getPwdRule().then(res=> {
        //     if(res.code == httpStatusCode.StatusOK) {
        //         setCookie('passwordRolu', res.data)
		// 		resolve(res.data);
		// 	} else {
		// 		reject(res.error);
		// 	}
		// })
	});
}


function comFun (value, callback, rules,userInfo) {
    let userPwsRegFilter = rules

    if(!value){
        return callback();
    }
    // step1 ,首先限制密码长度
    if(value.length < userPwsRegFilter.min || value.length > userPwsRegFilter.max){
        callback(`${languages.utils.checkPass.msg01}${userPwsRegFilter.min}${languages.utils.checkPass.msg02}${userPwsRegFilter.max}${languages.utils.checkPass.msg03}`)
        return
    }
    let checkRegNum = 0;
    //step 2, 验证密码字符
    //step 2-1, 是否今有数字
    let numReg = /[0-9]+/
    if(numReg.test(value)) {
        checkRegNum++
    }
    //step 2-2, 是否今有小写字母
    let azRegStr = /[a-z]+/;
    if(azRegStr.test(value)) {
        checkRegNum++
    }
    //step 2-3 是否含用大写字母
    let AZRegStr1 = /[A-Z]+/;
    if(AZRegStr1.test(value)) {
        checkRegNum++
    }
    //step 2-3 是否含有特殊字符
    let regEn = /[-_|`~!@#$%^&*()+<>?:"{},.\\/;'[\]]/im;
    let regCn = /[·＿！#￥（——）：；“”‘、|《。》？、【】[\]]/im;
    if(regEn.test(value) || regCn.test(value)) {
        checkRegNum++
    }

    if(userPwsRegFilter.complex == 1 && checkRegNum < 3){
        callback(languages.utils.checkPass.msg04)
        return
    }

    if(userPwsRegFilter.complex == 2 && checkRegNum < 4){
        callback(languages.utils.checkPass.msg05)
        return
    }
    //step3 是否开启重复字数
    if(userPwsRegFilter.repeat == 1) {
        let repeatNumMap = new Map();
        for(let index in value) {
            if(repeatNumMap.has(value[index])){
                repeatNumMap.set(value[index],repeatNumMap.get(value[index]) + 1)
            }else{
                repeatNumMap.set(value[index],1)
            }
        }
        for(let [name,value] of repeatNumMap) {
            if(value > userPwsRegFilter.repeatNum){
                callback(`${languages.utils.checkPass.msg06}${userPwsRegFilter.repeatNum}${languages.utils.checkPass.msg07}`)
                return
            }
        }
    }
    if(userPwsRegFilter.userInfo == 1){
        if(value.includes(userInfo.username)){
            //   this.$message.error("密码中不能包含用户名")
            callback(languages.utils.checkPass.msg08)
            return   }

        if(userInfo.phonesn!="" && value.includes(userInfo.phonesn)){
            //  this.$message.error("密码中不能包含手机号")
            callback(languages.utils.checkPass.msg09)
            return
        }
        if(userInfo.email){
            let emailData = userInfo.email.split("@")
            if(value.includes(emailData[0])){
                //this.$message.error("密码不能包含邮箱前缀")
                callback(languages.utils.checkPass.msg10)
                return
            }
        }
    }
    if(userPwsRegFilter.reverse == 1){
        let reverseStr = userInfo.username.split("").reverse().join("")//数组中的字符拼接回字符串
        if(value.includes(reverseStr)){
            //this.$message.error("密码中不能包含用户名倒写")
            callback(languages.utils.checkPass.msg11)
            return
        }
    }
    callback()
}
